module.exports = __webpack_public_path__ + "9f5f8021c8ad778b66c8695dd1a6cd95.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/brand_ambassadors/photo_selector/photo_selector_fiji.png
// module id = 566
// module chunks = 0